<template>
  <Head :title="reportGroup.id ? 'Edit Report Group' : 'Create Report Group'" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <report-group-builder :report-group="reportGroup"></report-group-builder>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  reportGroup: Object
});
</script>
